export default __webpack_public_path__ + "static/media/smartobject_pattern_circles.3a5f5962.png";